import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { PatientService } from "@main/app-layout/components/patient-switch/patient.service";
import { IEpisode } from "@project/models/episodes/episode";
import { debounceTime, fromEvent, Subscription, switchMap } from "rxjs";
import { EpisodeService } from "./episode.service";

@Component({
    selector: "move-episode-subentity-dialog",
    templateUrl: "./move-episode-subentity-dialog.component.html",
    styles: []
})
export class MoveEpisodeSubentityDialogComponent implements OnInit, OnDestroy {
    private _visible: boolean;
    private inputSubs: Subscription;

    loadingEpisodes = false;
    filteredEpisodes: IEpisode[] = [];
    selectedEpisodeId: string;

    @Input() set visible(visible: boolean) {
        if (visible) {
            this.onShow();
        }
        this._visible = visible;
        this.visibleChange.emit(visible);
    }
    get visible() {
        return this._visible;
    }
    @Input() movingEpisodeId: string;

    @Output() readonly ok = new EventEmitter<string>();
    @Output() readonly visibleChange = new EventEmitter<boolean>();

    @ViewChild("episodeNameInput", { static: true }) episodeNameInput: ElementRef<HTMLInputElement>;

    constructor(private episodeService: EpisodeService, private patientService: PatientService) {}

    async ngOnInit() {
        this.inputSubs = fromEvent(this.episodeNameInput.nativeElement, "input")
            .pipe(
                debounceTime(500),
                switchMap(_ => this.searchEpisodesByName())
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        this.inputSubs?.unsubscribe();
    }

    selectEpisode() {
        if (!this.selectedEpisodeId) {
            return;
        }

        this.ok.emit(this.selectedEpisodeId);
        this.visible = false;
    }

    private async onShow() {
        this.loadingEpisodes = false;
        this.filteredEpisodes = [];
        if (this.episodeNameInput?.nativeElement) {
            this.episodeNameInput.nativeElement.value = "";
        }
        await this.searchEpisodesByName();
    }

    private async searchEpisodesByName() {
        try {
            this.loadingEpisodes = true;
            this.selectedEpisodeId = null;

            const searchTerm = this.episodeNameInput?.nativeElement.value ?? "";
            this.filteredEpisodes = await this.episodeService.searchEpisodesByName(
                this.patientService.currentPatientId,
                searchTerm,
                this.movingEpisodeId
            );
        } catch {
            this.filteredEpisodes = [];
        } finally {
            this.loadingEpisodes = false;
        }
    }
}
